import { useMemo } from 'react';

import _ from 'lodash';

import { FeatureAppTrackingEvent, FeatureAppTrackingManager, TrackingEvent } from "../typings/tagging";
import { useFeatureServices } from './use-feature-services';

const defaultTrackingEvent: FeatureAppTrackingEvent = {
  eventInfo: {
    pageName: 'MyVW',
    pageCategory: 'MyVW',
  },

  environment: {
    featureAppIdAppVersion: process.env.APPVERSION,
    featureAppId: 'UserRegistration-D6-US',
  },
};

export const getDefaultTrackingEvent = () => {
  return _.cloneDeep(defaultTrackingEvent);
}

const buildTrackingEvent = (
  cusTrackEvent?: FeatureAppTrackingEvent,
): FeatureAppTrackingEvent => {
  let trackingEvent: FeatureAppTrackingEvent;

  if (cusTrackEvent) {
    trackingEvent = _.cloneDeep(cusTrackEvent);
  } else {
    trackingEvent = _.cloneDeep(defaultTrackingEvent);
  }

  return trackingEvent;
}

export function getTrackEventClone(): FeatureAppTrackingEvent {
  return _.cloneDeep(defaultTrackingEvent);
}

export const useTrackingManager = (): FeatureAppTrackingManager => {
  const trackingManager = useFeatureServices()['tracking']!;

  return useMemo((): FeatureAppTrackingManager => {
    const track = (action: string, event: FeatureAppTrackingEvent): void => {
      trackingManager && trackingManager.track(action, event as unknown as TrackingEvent)
    }

    return {
      trackMyVWGlobalEvent(
        event: string,
        trackEvent?: FeatureAppTrackingEvent
      ): void {
        track(event, buildTrackingEvent(trackEvent))
      }
    }
  }, [trackingManager])
}